<template>
  <StarField />
  <SiteNav />
  <main>
    <HeroOrbit />
    <LifeOSSection />
    <QuantSection />
    <JarvisSection />
    <AgendaVueSection />
    <ExperienceSection />
  </main>
  <SiteFooter />
</template>

<script>
import StarField from './components/StarField.vue';
import SiteNav from './components/SiteNav.vue';
import HeroOrbit from './components/HeroOrbit.vue';
import LifeOSSection from './components/sections/LifeOSSection.vue';
import QuantSection from './components/sections/QuantSection.vue';
import JarvisSection from './components/sections/JarvisSection.vue';
import AgendaVueSection from './components/sections/AgendaVueSection.vue';
import ExperienceSection from './components/sections/ExperienceSection.vue';
import SiteFooter from './components/SiteFooter.vue';

export default {
  name: 'App',
  components: {
    StarField,
    SiteNav,
    HeroOrbit,
    LifeOSSection,
    QuantSection,
    JarvisSection,
    AgendaVueSection,
    ExperienceSection,
    SiteFooter,
  },
};
</script>

<style>
@font-face {
  font-family: 'Satoshi';
  src: url('@/assets/fonts/Satoshi.woff') format('woff');
  font-weight: 400;
  font-display: swap;
}
</style>
